<div class="flex flex--align-center">
  <div class="flex__child spacing--padding-horizontal text-color--white text--body">
    <span *ngIf="data?.length > 0; else defaultError"> {{ 'cart.notification.errorWithMessages' | translate }}</span>

    <ul>
      <li *ngFor="let message of data">{{ message }}</li>
    </ul>

    <button mat-button (click)="dismiss()">
      {{ 'cart.notification.dismiss' | translate }}
    </button>
  </div>
</div>

<ng-template #defaultError>
  <span>{{ 'cart.notification.defaultError' | translate }}</span>
</ng-template>
